import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'

export const OpsotLogo = ({ width, height }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 90 30"
		fill="none"
		role="img"
		width={width}
		height={height}
	>
		<title>College of Policing Logo</title>
		<rect
			x="14.7773"
			y="7.69447"
			width="2.90378"
			height="2.86443"
			fill="#00AAFF"
		/>
		<path
			d="M9.59697 10.9989L11.6503 8.97341L13.7035 10.9989L11.6503 13.0243L9.59697 10.9989Z"
			fill="#00AAFF"
		/>
		<path
			d="M8.30469 16.9475V14.0831H11.2085V16.9475H8.30469Z"
			fill="#00AAFF"
		/>
		<path
			d="M11.6563 22.0545L9.60297 20.029L11.6562 18.0036L13.7095 20.029L11.6563 22.0545Z"
			fill="#00AAFF"
		/>
		<rect
			x="17.6836"
			y="23.3298"
			width="2.90378"
			height="2.86443"
			transform="rotate(-180 17.6836 23.3298)"
			fill="#00AAFF"
		/>
		<path
			d="M22.864 20.0257L20.8107 22.0511L18.7574 20.0257L20.8107 18.0002L22.864 20.0257Z"
			fill="#00AAFF"
		/>
		<path
			d="M24.1562 14.0768V16.9412H21.2525V14.0768H24.1562Z"
			fill="#00AAFF"
		/>
		<path
			d="M20.8047 8.96957L22.858 10.995L20.8047 13.0205L18.7514 10.995L20.8047 8.96957Z"
			fill="#00AAFF"
		/>
		<rect
			x="15.25"
			y="3.23917"
			width="1.95772"
			height="1.93119"
			fill="#00AAFF"
		/>
		<path
			d="M6.73654 7.51855L8.12087 6.153L9.50519 7.51855L8.12087 8.88411L6.73654 7.51855Z"
			fill="#00AAFF"
		/>
		<path
			d="M3.78906 16.4798V14.5487H5.74679V16.4798H3.78906Z"
			fill="#00AAFF"
		/>
		<path
			d="M8.125 24.8728L6.74068 23.5073L8.125 22.1417L9.50932 23.5073L8.125 24.8728Z"
			fill="#00AAFF"
		/>
		<rect
			x="17.2109"
			y="27.7851"
			width="1.95772"
			height="1.93119"
			transform="rotate(-180 17.2109 27.7851)"
			fill="#00AAFF"
		/>
		<path
			d="M25.7205 23.506L24.3362 24.8716L22.9518 23.506L24.3362 22.1405L25.7205 23.506Z"
			fill="#00AAFF"
		/>
		<path
			d="M28.6719 14.5445V16.4757H26.7142V14.5445H28.6719Z"
			fill="#00AAFF"
		/>
		<path
			d="M24.3359 6.15123L25.7203 7.51679L24.3359 8.88235L22.9516 7.51679L24.3359 6.15123Z"
			fill="#00AAFF"
		/>
		<rect x="15.5664" y="0.5" width="1.3249" height="1.30695" fill="#00AAFF" />
		<path
			d="M10.6492 1.53324L11.9023 1.10882L12.3326 2.34493L11.0795 2.76936L10.6492 1.53324Z"
			fill="#00AAFF"
		/>
		<path
			d="M6.33735 4.08588L7.38281 3.28304L8.19668 4.31434L7.15122 5.11717L6.33735 4.08588Z"
			fill="#00AAFF"
		/>
		<path
			d="M3.10288 7.88025L3.82738 6.78602L4.93664 7.5007L4.21214 8.59493L3.10288 7.88025Z"
			fill="#00AAFF"
		/>
		<path
			d="M1.28966 12.5039L1.61467 11.2368L2.89909 11.5574L2.57408 12.8245L1.28966 12.5039Z"
			fill="#00AAFF"
		/>
		<path
			d="M1.09766 17.4597L0.987943 16.1573L2.3083 16.049L2.41801 17.3515L1.09766 17.4597Z"
			fill="#00AAFF"
		/>
		<path
			d="M2.55078 22.2062L2.01824 21.0094L3.2314 20.4841L3.76395 21.6808L2.55078 22.2062Z"
			fill="#00AAFF"
		/>
		<path
			d="M5.48437 26.2332L4.58673 25.272L5.5612 24.3865L6.45885 25.3478L5.48437 26.2332Z"
			fill="#00AAFF"
		/>
		<path
			d="M9.58594 29.1005L8.42049 28.4789L9.05064 27.3292L10.2161 27.9509L9.58594 29.1005Z"
			fill="#00AAFF"
		/>
		<path
			d="M14.4102 30.5L13.1032 30.2854L13.3208 28.9962L14.6277 29.2108L14.4102 30.5Z"
			fill="#00AAFF"
		/>
		<path
			d="M19.4293 30.2779L18.1226 30.4936L17.9039 29.2046L19.2106 28.9889L19.4293 30.2779Z"
			fill="#00AAFF"
		/>
		<path
			d="M24.1082 28.4564L22.9433 29.079L22.3121 27.9299L23.477 27.3073L24.1082 28.4564Z"
			fill="#00AAFF"
		/>
		<path
			d="M27.9321 25.2402L27.0353 26.2023L26.0601 25.3176L26.9569 24.3556L27.9321 25.2402Z"
			fill="#00AAFF"
		/>
		<path
			d="M30.4873 20.9717L29.9558 22.1689L28.7422 21.6446L29.2736 20.4474L30.4873 20.9717Z"
			fill="#00AAFF"
		/>
		<path
			d="M31.4998 16.114L31.3913 17.4165L30.0708 17.3094L30.1794 16.0069L31.4998 16.114Z"
			fill="#00AAFF"
		/>
		<path
			d="M30.8594 11.1955L31.1855 12.4622L29.9014 12.7839L29.5752 11.5172L30.8594 11.1955Z"
			fill="#00AAFF"
		/>
		<path
			d="M28.6367 6.74899L29.3622 7.8426L28.2536 8.55824L27.5281 7.46463L28.6367 6.74899Z"
			fill="#00AAFF"
		/>
		<path
			d="M25.0703 3.25613L26.1165 4.05807L25.3035 5.09006L24.2574 4.28813L25.0703 3.25613Z"
			fill="#00AAFF"
		/>
		<path
			d="M20.7383 1.02402L21.9969 1.44224L21.573 2.68384L20.3143 2.26562L20.7383 1.02402Z"
			fill="#00AAFF"
		/>
		<path
			d="M10.432 5.91576L13.3862 4.69675L14.6211 7.60895L11.667 8.82795L10.432 5.91576Z"
			fill="#00AAFF"
		/>
		<path
			d="M5.2523 12.7688L6.46739 9.84624L9.42814 11.0441L8.21305 13.9666L5.2523 12.7688Z"
			fill="#00AAFF"
		/>
		<path
			d="M6.50391 21.2301L5.26816 18.316L8.22036 17.0978L9.45611 20.0119L6.50391 21.2301Z"
			fill="#00AAFF"
		/>
		<path
			d="M13.4531 26.3407L10.4904 25.142L11.7047 22.2214L14.6674 23.42L13.4531 26.3407Z"
			fill="#00AAFF"
		/>
		<path
			d="M22.0289 25.1072L19.0748 26.3262L17.8398 23.414L20.794 22.195L22.0289 25.1072Z"
			fill="#00AAFF"
		/>
		<path
			d="M27.2086 18.2549L25.9935 21.1775L23.0328 19.9796L24.2479 17.0571L27.2086 18.2549Z"
			fill="#00AAFF"
		/>
		<path
			d="M25.9609 9.79266L27.1967 12.7068L24.2445 13.925L23.0087 11.0109L25.9609 9.79266Z"
			fill="#00AAFF"
		/>
		<path
			d="M19.0078 4.68216L21.9705 5.88079L20.7562 8.80141L17.7935 7.60279L19.0078 4.68216Z"
			fill="#00AAFF"
		/>
		<path
			d="M35 9.78434V9.76138C35 7.42307 36.7715 5.4877 39.2329 5.4877C40.7525 5.4877 41.6626 6.018 42.4986 6.79674L41.8637 7.48153C41.1568 6.82179 40.3673 6.34787 39.2308 6.34787C37.3747 6.34787 35.9863 7.83645 35.9863 9.73841V9.76138C35.9863 11.6738 37.3874 13.1728 39.2308 13.1728C40.38 13.1728 41.1356 12.7365 41.9356 11.9807L42.5579 12.582C41.6838 13.4567 40.7271 14.0434 39.2075 14.0434C36.7821 14.0351 35 12.1581 35 9.78434Z"
			fill="#2E2C70"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M43.1838 10.8491V10.87C43.1741 11.7125 43.5089 12.5233 44.1127 13.1193C44.7165 13.7153 45.5382 14.0462 46.3924 14.0371C47.2529 14.045 48.0806 13.7119 48.6901 13.1127C49.2996 12.5134 49.6399 11.698 49.6348 10.8491V10.8261C49.6283 9.06887 48.179 7.64949 46.3976 7.65583C44.6163 7.66217 43.1774 9.09184 43.1838 10.8491ZM48.6866 10.8491V10.8699H48.6887C48.6887 12.1581 47.7554 13.2208 46.4135 13.2229C45.1098 13.2229 44.1277 12.1602 44.1277 10.8491V10.8261C44.1277 9.53794 45.0484 8.46482 46.3902 8.46482C47.694 8.46482 48.6866 9.53794 48.6866 10.8491Z"
			fill="#2E2C70"
		/>
		<path
			d="M51.0312 5.27475H51.9519V13.8931H51.0312V5.27475Z"
			fill="#2E2C70"
		/>
		<path
			d="M53.8125 5.27475H54.7353V13.8931H53.8125V5.27475Z"
			fill="#2E2C70"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M61.1954 12.3815C60.7038 12.9363 59.9909 13.2514 59.244 13.2438C58.1561 13.2438 57.1974 12.5005 57.0662 11.2124H61.9679C61.9785 11.0725 61.9785 10.9765 61.9785 10.895V10.895C61.9785 9.09955 60.9266 7.65898 59.0959 7.65898C57.39 7.65898 56.1328 9.07658 56.1328 10.847C56.1328 12.749 57.5276 14.035 59.2207 14.035C60.2045 14.0613 61.1456 13.6384 61.7711 12.8889L61.1954 12.3815ZM59.0768 8.42728C60.298 8.42728 60.9435 9.37096 61.0515 10.4817H57.0662C57.1974 9.29997 58.0186 8.42728 59.0768 8.42728Z"
			fill="#2E2C70"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M63.5943 14.248L63.171 14.9558C63.9966 15.5199 64.9796 15.8168 65.9838 15.8055C66.9658 15.8055 67.7913 15.5341 68.3415 14.9913C68.8431 14.5006 69.131 13.7762 69.131 12.8304V7.78843H68.2103V8.8866C67.6597 8.10761 66.7539 7.64796 65.7912 7.65898C65.0149 7.64986 64.268 7.95089 63.7202 8.49357C63.1725 9.03625 62.8706 9.77442 62.8832 10.5401V10.5631C62.8739 11.3255 63.1778 12.0592 63.7255 12.5972C64.2733 13.1351 65.0184 13.4316 65.7912 13.4192C66.9299 13.4192 67.6833 12.8408 68.2209 12.1331V12.8534C68.2209 14.2814 67.3362 15.0247 65.9711 15.0247C65.1144 15.0268 64.2803 14.7542 63.5943 14.248ZM65.9753 8.46278C67.1479 8.46278 68.2505 9.27492 68.2505 10.5276V10.5526H68.2463C68.2463 11.7803 67.1436 12.6175 65.9753 12.6279C65.4077 12.641 64.8591 12.426 64.4553 12.0324C64.0514 11.6387 63.827 11.1001 63.8335 10.5401V10.5171C63.8335 9.26448 64.8028 8.46278 65.9753 8.46278Z"
			fill="#2E2C70"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M75.5072 12.3815C75.0153 12.9359 74.3027 13.2508 73.5559 13.2438C72.4659 13.2438 71.5092 12.5005 71.378 11.2124H76.2882C76.3009 11.0725 76.3009 10.9765 76.3009 10.895C76.3009 9.09955 75.2469 7.65898 73.4162 7.65898C71.7103 7.65898 70.4531 9.07658 70.4531 10.847C70.4531 12.749 71.8479 14.035 73.541 14.035C74.5213 14.0587 75.458 13.6359 76.0808 12.8889L75.5072 12.3815ZM73.3929 8.42728C74.6141 8.42728 75.2596 9.37096 75.3675 10.4817H71.3822C71.5135 9.29997 72.3347 8.42728 73.3929 8.42728Z"
			fill="#2E2C70"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M79.9924 10.8491V10.87C79.9832 11.7118 80.318 12.5217 80.9213 13.1172C81.5245 13.7127 82.3454 14.0435 83.1988 14.035C84.0595 14.0434 84.8877 13.711 85.4979 13.1122C86.1082 12.5134 86.4495 11.6982 86.4455 10.8491V10.8261C86.3948 9.09989 84.9582 7.72824 83.2076 7.73447C81.4569 7.7407 80.0304 9.12254 79.9924 10.8491ZM85.4952 10.8491V10.8699H85.4994C85.4994 12.1581 84.566 13.2208 83.22 13.2229C81.9162 13.2229 80.9342 12.1602 80.9342 10.8491V10.8261C80.9342 9.53794 81.857 8.46482 83.1967 8.46482C84.5004 8.46482 85.4952 9.53794 85.4952 10.8491Z"
			fill="#2E2C70"
		/>
		<path
			d="M88.0966 8.59221H87.25V7.80095H88.0966V7.27065C88.0966 6.57333 88.2892 6.04095 88.6363 5.69856C88.9991 5.36926 89.4817 5.19903 89.9739 5.22672C90.3193 5.2156 90.6638 5.26799 90.9898 5.38121V6.17248C90.7003 6.07659 90.3977 6.0245 90.0924 6.01799C89.3749 6.01799 89.0151 6.43554 89.0151 7.31658V7.81347H90.9792V8.59221H89.0278V13.8931H88.105L88.0966 8.59221Z"
			fill="#2E2C70"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M38.6137 17.4214H35.1914V25.6869H37.0348V23.2066H38.4359C40.3132 23.2066 41.8223 22.215 41.8223 20.3025V20.2796C41.8223 18.5906 40.6138 17.4214 38.6137 17.4214ZM39.9556 20.3443C39.9556 21.0521 39.4159 21.597 38.4952 21.597H37.0348V19.0687H38.4592C39.3799 19.0687 39.9556 19.5071 39.9556 20.3213V20.3443Z"
			fill="#2E2C70"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M42.3828 22.5407V22.5574C42.3828 24.3758 43.8389 25.8352 45.8411 25.8352C47.8433 25.8352 49.3248 24.3591 49.3248 22.5407V22.5177C49.3248 20.7076 47.8687 19.2461 45.8665 19.2461C43.8643 19.2461 42.3828 20.7222 42.3828 22.5407ZM47.53 22.5407V22.5574C47.53 23.4906 46.9078 24.2819 45.8665 24.2881C44.857 24.2881 44.1733 23.4739 44.1733 22.5407V22.5177C44.1733 21.5844 44.7956 20.7932 45.8369 20.7932C46.8464 20.7932 47.53 21.6074 47.53 22.5407Z"
			fill="#2E2C70"
		/>
		<path
			d="M50.4868 17.0686H52.3006V25.6869H50.4805L50.4868 17.0686Z"
			fill="#2E2C70"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M55.7279 17.0686H53.8125V18.6616H55.7279V17.0686ZM55.6856 19.3651H53.8612L53.8675 25.6932H55.6856V19.3651Z"
			fill="#2E2C70"
		/>
		<path
			d="M56.8402 22.5574V22.5407C56.8279 21.6592 57.1791 20.8107 57.8132 20.1896C58.4472 19.5684 59.3098 19.2279 60.2032 19.2461C61.4138 19.2461 62.1673 19.647 62.7663 20.3088L61.653 21.4905C61.2466 21.073 60.8382 20.7932 60.1927 20.7932C59.2826 20.7932 58.6371 21.5845 58.6371 22.5177V22.5407C58.6371 23.5094 59.272 24.2881 60.2646 24.2881C60.8742 24.2881 61.2932 24.0292 61.7356 23.6159L62.7938 24.6785C62.1507 25.4469 61.1807 25.8747 60.1715 25.8352C59.2849 25.8499 58.4302 25.5096 57.8024 24.8919C57.1746 24.2742 56.8275 23.4319 56.8402 22.5574Z"
			fill="#2E2C70"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M65.6966 17.0686H63.7812V18.6616H65.6966V17.0686ZM65.648 19.3651H63.8299V25.6932H65.648V19.3651Z"
			fill="#2E2C70"
		/>
		<path
			d="M67.1133 19.3589H68.9313V20.2566C69.3546 19.7242 69.8901 19.2399 70.8107 19.2399C72.1864 19.2399 72.9886 20.1376 72.9886 21.5907V25.6869H71.1769V22.1565C71.1769 21.3068 70.7684 20.8704 70.0742 20.8704C69.38 20.8704 68.9377 21.3068 68.9377 22.1565V25.6869H67.1133V19.3589Z"
			fill="#2E2C70"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M74.9929 25.593L74.3707 26.9375C75.2484 27.3789 76.2217 27.6032 77.2067 27.591C78.4512 27.591 79.374 27.3321 79.973 26.7413C80.5105 26.2089 80.7857 25.3842 80.7857 24.2505V19.3505H78.9676V20.1856C78.462 19.5717 77.6973 19.2227 76.8956 19.2399C75.4247 19.2399 74.0469 20.3026 74.0469 22.192V22.215C74.0469 24.0919 75.3993 25.1671 76.8956 25.1671C77.865 25.1671 78.4512 24.7787 78.9909 24.1399V24.4468C78.9909 25.5805 78.4047 26.1713 77.1602 26.1713C76.3979 26.1765 75.6486 25.9765 74.9929 25.593ZM78.9909 22.192V22.215C78.9909 23.0772 78.3073 23.6764 77.4226 23.6764C76.5379 23.6764 75.867 23.0897 75.867 22.215V22.192C75.867 21.3318 76.5358 20.7306 77.4226 20.7306C78.3094 20.7306 78.9909 21.3297 78.9909 22.192Z"
			fill="#2E2C70"
		/>
	</svg>
)

export const OpsotHomeIcon = () => (
	<SvgIcon>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
		>
			<title>Home</title>
			<path
				d="M6.84375 19H9.84375V13H15.8438V19H18.8438V10L12.8438 5.5L6.84375 10V19ZM4.84375 21V9L12.8438 3L20.8438 9V21H13.8438V15H11.8438V21H4.84375Z"
				fill="currentColor"
			/>
		</svg>
	</SvgIcon>
)
export const OpsotSearchIcon = () => (
	<SvgIcon>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
		>
			<title>Search</title>
			<path
				d="M16.7956 20.1176H12.06H8.8775C8.67167 20.6667 8.32729 21.1176 7.84438 21.4706C7.36146 21.8235 6.81125 22 6.19375 22C5.40208 22 4.72917 21.7255 4.175 21.1765C3.62083 20.6275 3.34375 19.9608 3.34375 19.1765C3.34375 18.5647 3.52187 18.0196 3.87813 17.5412C4.23438 17.0627 4.68958 16.7216 5.24375 16.5176V8.65882C4.68958 8.4549 4.23438 8.11373 3.87813 7.63529C3.52187 7.15686 3.34375 6.61176 3.34375 6C3.34375 5.21569 3.62083 4.54902 4.175 4C4.72917 3.45098 5.40208 3.17647 6.19375 3.17647C6.81125 3.17647 7.36146 3.35294 7.84438 3.70588C8.32729 4.05882 8.67167 4.5098 8.8775 5.05882H12.06L10.3262 3.34118L11.6562 2L15.6937 6L11.6562 10L10.3262 8.65882L12.06 6.94118H8.8775C8.735 7.34902 8.51333 7.70196 8.2125 8C7.91167 8.29804 7.55542 8.51765 7.14375 8.65882V16.5176C7.55542 16.6588 7.91167 16.8784 8.2125 17.1765C8.51333 17.4745 8.735 17.8275 8.8775 18.2353H12.06H17.1187V19.1765L16.7956 20.1176ZM19.4937 22C18.7021 22 18.0292 21.7255 17.475 21.1765C16.9208 20.6275 16.6438 19.9608 16.6438 19.1765C16.6438 18.549 16.8219 17.9961 17.1781 17.5176C17.5344 17.0392 17.9896 16.7059 18.5437 16.5176V8.65882C17.9896 8.47059 17.5344 8.13726 17.1781 7.65882C16.8219 7.18039 16.6438 6.62745 16.6438 6C16.6438 5.21569 16.9208 4.54902 17.475 4C18.0292 3.45098 18.7021 3.17647 19.4937 3.17647C20.2854 3.17647 20.9583 3.45098 21.5125 4C22.0667 4.54902 22.3438 5.21569 22.3438 6C22.3438 6.62745 22.1656 7.18039 21.8094 7.65882C21.4531 8.13726 20.9979 8.47059 20.4438 8.65882V16.5176C20.9979 16.7216 21.4531 17.0627 21.8094 17.5412C22.1656 18.0196 22.3438 18.5647 22.3438 19.1765C22.3438 19.9608 22.0667 20.6275 21.5125 21.1765C20.9583 21.7255 20.2854 22 19.4937 22ZM6.19375 20.1176C6.46292 20.1176 6.68854 20.0275 6.87063 19.8471C7.05271 19.6667 7.14375 19.4431 7.14375 19.1765C7.14375 18.9098 7.05271 18.6863 6.87063 18.5059C6.68854 18.3255 6.46292 18.2353 6.19375 18.2353C5.92458 18.2353 5.69896 18.3255 5.51688 18.5059C5.33479 18.6863 5.24375 18.9098 5.24375 19.1765C5.24375 19.4431 5.33479 19.6667 5.51688 19.8471C5.69896 20.0275 5.92458 20.1176 6.19375 20.1176ZM19.4937 20.1176C19.7629 20.1176 19.9885 20.0275 20.1706 19.8471C20.3527 19.6667 20.4438 19.4431 20.4438 19.1765C20.4438 18.9098 20.3527 18.6863 20.1706 18.5059C19.9885 18.3255 19.7629 18.2353 19.4937 18.2353C19.2246 18.2353 18.999 18.3255 18.8169 18.5059C18.6348 18.6863 18.5437 18.9098 18.5437 19.1765C18.5437 19.4431 18.6348 19.6667 18.8169 19.8471C18.999 20.0275 19.2246 20.1176 19.4937 20.1176ZM6.19375 6.94118C6.46292 6.94118 6.68854 6.85098 6.87063 6.67059C7.05271 6.4902 7.14375 6.26667 7.14375 6C7.14375 5.73333 7.05271 5.5098 6.87063 5.32941C6.68854 5.14902 6.46292 5.05882 6.19375 5.05882C5.92458 5.05882 5.69896 5.14902 5.51688 5.32941C5.33479 5.5098 5.24375 5.73333 5.24375 6C5.24375 6.26667 5.33479 6.4902 5.51688 6.67059C5.69896 6.85098 5.92458 6.94118 6.19375 6.94118ZM19.4937 6.94118C19.7629 6.94118 19.9885 6.85098 20.1706 6.67059C20.3527 6.4902 20.4438 6.26667 20.4438 6C20.4438 5.73333 20.3527 5.5098 20.1706 5.32941C19.9885 5.14902 19.7629 5.05882 19.4937 5.05882C19.2246 5.05882 18.999 5.14902 18.8169 5.32941C18.6348 5.5098 18.5437 5.73333 18.5437 6C18.5437 6.26667 18.6348 6.4902 18.8169 6.67059C18.999 6.85098 19.2246 6.94118 19.4937 6.94118Z"
				fill="currentColor"
			/>
		</svg>
	</SvgIcon>
)
export const OpsotProcessGuideIcon = () => (
	<SvgIcon>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
		>
			<title>Process Guide</title>

			<path
				d="M16.7956 20.1176H12.06H8.8775C8.67167 20.6667 8.32729 21.1176 7.84438 21.4706C7.36146 21.8235 6.81125 22 6.19375 22C5.40208 22 4.72917 21.7255 4.175 21.1765C3.62083 20.6275 3.34375 19.9608 3.34375 19.1765C3.34375 18.5647 3.52187 18.0196 3.87813 17.5412C4.23438 17.0627 4.68958 16.7216 5.24375 16.5176V8.65882C4.68958 8.4549 4.23438 8.11373 3.87813 7.63529C3.52187 7.15686 3.34375 6.61176 3.34375 6C3.34375 5.21569 3.62083 4.54902 4.175 4C4.72917 3.45098 5.40208 3.17647 6.19375 3.17647C6.81125 3.17647 7.36146 3.35294 7.84438 3.70588C8.32729 4.05882 8.67167 4.5098 8.8775 5.05882H12.06L10.3262 3.34118L11.6562 2L15.6937 6L11.6562 10L10.3262 8.65882L12.06 6.94118H8.8775C8.735 7.34902 8.51333 7.70196 8.2125 8C7.91167 8.29804 7.55542 8.51765 7.14375 8.65882V16.5176C7.55542 16.6588 7.91167 16.8784 8.2125 17.1765C8.51333 17.4745 8.735 17.8275 8.8775 18.2353H12.06H17.1187V19.1765L16.7956 20.1176ZM19.4937 22C18.7021 22 18.0292 21.7255 17.475 21.1765C16.9208 20.6275 16.6438 19.9608 16.6438 19.1765C16.6438 18.549 16.8219 17.9961 17.1781 17.5176C17.5344 17.0392 17.9896 16.7059 18.5437 16.5176V8.65882C17.9896 8.47059 17.5344 8.13726 17.1781 7.65882C16.8219 7.18039 16.6438 6.62745 16.6438 6C16.6438 5.21569 16.9208 4.54902 17.475 4C18.0292 3.45098 18.7021 3.17647 19.4937 3.17647C20.2854 3.17647 20.9583 3.45098 21.5125 4C22.0667 4.54902 22.3438 5.21569 22.3438 6C22.3438 6.62745 22.1656 7.18039 21.8094 7.65882C21.4531 8.13726 20.9979 8.47059 20.4438 8.65882V16.5176C20.9979 16.7216 21.4531 17.0627 21.8094 17.5412C22.1656 18.0196 22.3438 18.5647 22.3438 19.1765C22.3438 19.9608 22.0667 20.6275 21.5125 21.1765C20.9583 21.7255 20.2854 22 19.4937 22ZM6.19375 20.1176C6.46292 20.1176 6.68854 20.0275 6.87063 19.8471C7.05271 19.6667 7.14375 19.4431 7.14375 19.1765C7.14375 18.9098 7.05271 18.6863 6.87063 18.5059C6.68854 18.3255 6.46292 18.2353 6.19375 18.2353C5.92458 18.2353 5.69896 18.3255 5.51688 18.5059C5.33479 18.6863 5.24375 18.9098 5.24375 19.1765C5.24375 19.4431 5.33479 19.6667 5.51688 19.8471C5.69896 20.0275 5.92458 20.1176 6.19375 20.1176ZM19.4937 20.1176C19.7629 20.1176 19.9885 20.0275 20.1706 19.8471C20.3527 19.6667 20.4438 19.4431 20.4438 19.1765C20.4438 18.9098 20.3527 18.6863 20.1706 18.5059C19.9885 18.3255 19.7629 18.2353 19.4937 18.2353C19.2246 18.2353 18.999 18.3255 18.8169 18.5059C18.6348 18.6863 18.5437 18.9098 18.5437 19.1765C18.5437 19.4431 18.6348 19.6667 18.8169 19.8471C18.999 20.0275 19.2246 20.1176 19.4937 20.1176ZM6.19375 6.94118C6.46292 6.94118 6.68854 6.85098 6.87063 6.67059C7.05271 6.4902 7.14375 6.26667 7.14375 6C7.14375 5.73333 7.05271 5.5098 6.87063 5.32941C6.68854 5.14902 6.46292 5.05882 6.19375 5.05882C5.92458 5.05882 5.69896 5.14902 5.51688 5.32941C5.33479 5.5098 5.24375 5.73333 5.24375 6C5.24375 6.26667 5.33479 6.4902 5.51688 6.67059C5.69896 6.85098 5.92458 6.94118 6.19375 6.94118ZM19.4937 6.94118C19.7629 6.94118 19.9885 6.85098 20.1706 6.67059C20.3527 6.4902 20.4438 6.26667 20.4438 6C20.4438 5.73333 20.3527 5.5098 20.1706 5.32941C19.9885 5.14902 19.7629 5.05882 19.4937 5.05882C19.2246 5.05882 18.999 5.14902 18.8169 5.32941C18.6348 5.5098 18.5437 5.73333 18.5437 6C18.5437 6.26667 18.6348 6.4902 18.8169 6.67059C18.999 6.85098 19.2246 6.94118 19.4937 6.94118Z"
				fill="currentColor"
			/>
		</svg>
	</SvgIcon>
)
export const OpsotToolkitIcon = () => (
	<SvgIcon>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
		>
			<title>Toolkit</title>

			<path
				d="M9.34375 18H17.3438V16H9.34375V18ZM9.34375 14H17.3438V12H9.34375V14ZM7.34375 22C6.79375 22 6.32292 21.8042 5.93125 21.4125C5.53958 21.0208 5.34375 20.55 5.34375 20V4C5.34375 3.45 5.53958 2.97917 5.93125 2.5875C6.32292 2.19583 6.79375 2 7.34375 2H15.3438L21.3438 8V20C21.3438 20.55 21.1479 21.0208 20.7563 21.4125C20.3646 21.8042 19.8938 22 19.3438 22H7.34375ZM14.3438 9V4H7.34375V20H19.3438V9H14.3438Z"
				fill="currentColor"
			/>
		</svg>
	</SvgIcon>
)
export const OpsotExitIcon = () => (
	<SvgIcon>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="white"
		>
			<title>Exit</title>
			<path
				d="M19.8438 18.5V14.5C19.8438 13.6667 19.5521 12.9583 18.9688 12.375C18.3854 11.7917 17.6771 11.5 16.8438 11.5H7.66875L11.2688 15.1L9.84375 16.5L3.84375 10.5L9.84375 4.5L11.2688 5.9L7.66875 9.5H16.8438C18.2271 9.5 19.4062 9.9875 20.3813 10.9625C21.3563 11.9375 21.8438 13.1167 21.8438 14.5V18.5H19.8438Z"
				fill="white"
			/>
		</svg>
	</SvgIcon>
)

export const OpsotXIcon = () => (
	<SvgIcon>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="26"
			height="26"
			viewBox="0 0 26 26"
			fill="none"
		>
			<title>College of Policing X Account</title>
			<circle cx="13" cy="13" r="12" stroke="white" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.3178 7H6L11.1028 13.6168L6.33645 19H8.35514L12 14.7944L15.3084 19H19.4019L14.1869 12.1028L18.6168 7H16.7103L13.1776 10.8692L10.3178 7ZM8.3551 8.0654H9.64482L17.0467 17.8224H15.8691L8.3551 8.0654Z"
				fill="white"
			/>
		</svg>
	</SvgIcon>
)

export const OpsotLinkedInIcon = () => (
	<SvgIcon>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="26"
			height="26"
			viewBox="0 0 26 26"
			fill="none"
		>
			<title>College of Policing LinkedIn Account</title>
			<circle cx="13" cy="13" r="12" stroke="white" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.9631 6.05479C8.78315 6.05479 9.44772 6.7595 9.44772 7.62617C9.44772 8.49385 8.78315 9.19805 7.9631 9.19805C7.14018 9.19805 6.47656 8.49385 6.47656 7.62617C6.47656 6.7595 7.14018 6.05479 7.9631 6.05479ZM6.67969 19.1132H9.24443V10.3912H6.67969V19.1132Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.8516 10.3912H13.3074V11.5828H13.3429C13.6845 10.8969 14.5204 10.1739 15.7666 10.1739C18.3591 10.1739 18.8385 11.9798 18.8385 14.329V19.1132H16.279V14.8717C16.279 13.8604 16.2603 12.5591 14.9475 12.5591C13.614 12.5591 13.4105 13.6603 13.4105 14.7986V19.1132H10.8516V10.3912Z"
				fill="white"
			/>
		</svg>
	</SvgIcon>
)

export const OpsotFacebookIcon = () => (
	<SvgIcon>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="26"
			height="26"
			viewBox="0 0 26 26"
			fill="none"
		>
			<title>College of Policing Facebook Account</title>
			<circle cx="13" cy="13" r="12" stroke="white" />
			<mask
				id="mask0_4473_75413"
				style={{ maskType: 'luminance' }}
				maskUnits="userSpaceOnUse"
				x="8"
				y="6"
				width="9"
				height="15"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12.5066 20.7743H16.0953V6.33099H12.5066H8.91797V20.7743H12.5066Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask0_4473_75413)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M13.5766 20.7743V14.1861H15.6928L16.0096 11.6185H13.5766V9.97917C13.5766 9.2358 13.7741 8.72916 14.7942 8.72916L16.0953 8.72859V6.43215C15.8702 6.40092 15.0979 6.33099 14.1995 6.33099C12.3237 6.33099 11.0395 7.52753 11.0395 9.72496V11.6185H8.91797V14.1861H11.0395V20.7743H13.5766Z"
					fill="white"
				/>
			</g>
		</svg>
	</SvgIcon>
)

export const OpsotLogoInverse = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="187"
		height="63"
		viewBox="0 0 187 63"
		fill="none"
	>
		<title>College of Policing Logo Inverse</title>

		<rect
			x="28.6484"
			y="15.1084"
			width="6.03341"
			height="6.0153"
			fill="#00AAFF"
		/>
		<path
			d="M17.8856 22.0476L22.1519 17.7942L26.4181 22.0476L22.1519 26.3011L17.8856 22.0476Z"
			fill="#00AAFF"
		/>
		<path
			d="M15.2031 34.5397V28.5245H21.2365V34.5397H15.2031Z"
			fill="#00AAFF"
		/>
		<path
			d="M22.1641 45.2644L17.8978 41.0109L22.1641 36.7575L26.4303 41.0109L22.1641 45.2644Z"
			fill="#00AAFF"
		/>
		<rect
			x="34.6914"
			y="47.9426"
			width="6.03341"
			height="6.0153"
			transform="rotate(-180 34.6914 47.9426)"
			fill="#00AAFF"
		/>
		<path
			d="M45.4543 41.0039L41.188 45.2574L36.9217 41.0039L41.188 36.7505L45.4543 41.0039Z"
			fill="#00AAFF"
		/>
		<path
			d="M48.1406 28.5113V34.5266H42.1072V28.5113H48.1406Z"
			fill="#00AAFF"
		/>
		<path
			d="M41.1758 17.7861L45.442 22.0396L41.1758 26.293L36.9095 22.0396L41.1758 17.7861Z"
			fill="#00AAFF"
		/>
		<rect
			x="29.6289"
			y="5.75224"
			width="4.06772"
			height="4.05551"
			fill="#00AAFF"
		/>
		<path
			d="M11.9459 14.739L14.8222 11.8713L17.6985 14.739L14.8222 17.6066L11.9459 14.739Z"
			fill="#00AAFF"
		/>
		<path
			d="M5.82031 33.5577V29.5022H9.88803V33.5577H5.82031Z"
			fill="#00AAFF"
		/>
		<path
			d="M14.832 51.1829L11.9557 48.3152L14.832 45.4476L17.7083 48.3152L14.832 51.1829Z"
			fill="#00AAFF"
		/>
		<rect
			x="33.7109"
			y="57.2988"
			width="4.06772"
			height="4.0555"
			transform="rotate(-180 33.7109 57.2988)"
			fill="#00AAFF"
		/>
		<path
			d="M51.39 48.3126L48.5137 51.1803L45.6374 48.3126L48.5137 45.4449L51.39 48.3126Z"
			fill="#00AAFF"
		/>
		<path
			d="M57.5195 29.4934V33.5489H53.4518V29.4934H57.5195Z"
			fill="#00AAFF"
		/>
		<path
			d="M48.5078 11.8676L51.3841 14.7353L48.5078 17.6029L45.6315 14.7353L48.5078 11.8676Z"
			fill="#00AAFF"
		/>
		<rect x="30.2891" width="2.75286" height="2.74459" fill="#00AAFF" />
		<path
			d="M20.0681 2.1698L22.6717 1.27851L23.5657 3.87435L20.9621 4.76564L20.0681 2.1698Z"
			fill="#00AAFF"
		/>
		<path
			d="M11.1162 7.53036L13.2884 5.8444L14.9795 8.01011L12.8073 9.69608L11.1162 7.53036Z"
			fill="#00AAFF"
		/>
		<path
			d="M4.39336 15.4985L5.89871 13.2007L8.20352 14.7015L6.69816 16.9994L4.39336 15.4985Z"
			fill="#00AAFF"
		/>
		<path
			d="M0.630153 25.2081L1.30545 22.5474L3.97419 23.2206L3.2989 25.8814L0.630153 25.2081Z"
			fill="#00AAFF"
		/>
		<path
			d="M0.226562 35.6154L-0.00139646 32.8803L2.742 32.653L2.96996 35.3881L0.226562 35.6154Z"
			fill="#00AAFF"
		/>
		<path
			d="M3.24609 45.5829L2.13959 43.0698L4.66028 41.9666L5.76678 44.4798L3.24609 45.5829Z"
			fill="#00AAFF"
		/>
		<path
			d="M9.33984 54.0398L7.47473 52.0211L9.49948 50.1616L11.3646 52.1803L9.33984 54.0398Z"
			fill="#00AAFF"
		/>
		<path
			d="M17.8633 60.0611L15.4417 58.7557L16.7511 56.3414L19.1726 57.6468L17.8633 60.0611Z"
			fill="#00AAFF"
		/>
		<path
			d="M27.8828 63L25.1673 62.5494L25.6193 59.842L28.3348 60.2927L27.8828 63Z"
			fill="#00AAFF"
		/>
		<path
			d="M38.3156 62.5336L35.6005 62.9866L35.1461 60.2796L37.8612 59.8267L38.3156 62.5336Z"
			fill="#00AAFF"
		/>
		<path
			d="M48.0366 58.7084L45.6162 60.0159L44.3048 57.6028L46.7252 56.2953L48.0366 58.7084Z"
			fill="#00AAFF"
		/>
		<path
			d="M55.9852 51.9545L54.1219 53.9748L52.0955 52.117L53.9589 50.0968L55.9852 51.9545Z"
			fill="#00AAFF"
		/>
		<path
			d="M61.2948 42.9905L60.1905 45.5046L57.6688 44.4036L58.7731 41.8895L61.2948 42.9905Z"
			fill="#00AAFF"
		/>
		<path
			d="M63.3981 32.7893L63.1725 35.5247L60.4289 35.2998L60.6545 32.5644L63.3981 32.7893Z"
			fill="#00AAFF"
		/>
		<path
			d="M62.0703 22.4605L62.7479 25.1206L60.0798 25.7962L59.4022 23.1361L62.0703 22.4605Z"
			fill="#00AAFF"
		/>
		<path
			d="M57.4453 13.1229L58.9527 15.4194L56.6492 16.9223L55.1418 14.6257L57.4453 13.1229Z"
			fill="#00AAFF"
		/>
		<path
			d="M50.0352 5.78789L52.2089 7.47196L50.5197 9.63914L48.346 7.95507L50.0352 5.78789Z"
			fill="#00AAFF"
		/>
		<path
			d="M41.0352 1.10042L43.6504 1.97869L42.7695 4.58605L40.1542 3.70778L41.0352 1.10042Z"
			fill="#00AAFF"
		/>
		<path
			d="M19.6259 11.3731L25.764 8.81317L28.3299 14.9288L22.1919 17.4887L19.6259 11.3731Z"
			fill="#00AAFF"
		/>
		<path
			d="M8.86024 25.7645L11.3849 19.6271L17.5367 22.1426L15.012 28.2799L8.86024 25.7645Z"
			fill="#00AAFF"
		/>
		<path
			d="M11.457 43.5333L8.88942 37.4136L15.0234 34.8554L17.591 40.9751L11.457 43.5333Z"
			fill="#00AAFF"
		/>
		<path
			d="M25.8945 54.2654L19.7387 51.7483L22.2617 45.615L28.4176 48.1321L25.8945 54.2654Z"
			fill="#00AAFF"
		/>
		<path
			d="M43.7139 51.6751L37.5758 54.235L35.0099 48.1194L41.148 45.5595L43.7139 51.6751Z"
			fill="#00AAFF"
		/>
		<path
			d="M54.4796 37.2853L51.9549 43.4227L45.8031 40.9072L48.3278 34.7699L54.4796 37.2853Z"
			fill="#00AAFF"
		/>
		<path
			d="M51.8867 19.5146L54.4543 25.6342L48.3203 28.1924L45.7527 22.0728L51.8867 19.5146Z"
			fill="#00AAFF"
		/>
		<path
			d="M37.4414 8.78252L43.5973 11.2996L41.0742 17.4329L34.9184 14.9158L37.4414 8.78252Z"
			fill="#00AAFF"
		/>
		<path
			d="M70.668 19.4971V19.4489C70.668 14.5384 74.3487 10.4742 79.463 10.4742C82.6205 10.4742 84.5114 11.5878 86.2484 13.2231L84.9292 14.6612C83.4604 13.2758 81.8201 12.2805 79.4586 12.2805C75.602 12.2805 72.7172 15.4065 72.7172 19.4007V19.4489C72.7172 23.4649 75.6284 26.6129 79.4586 26.6129C81.8465 26.6129 83.4164 25.6966 85.0787 24.1094L86.3716 25.3721C84.5554 27.2092 82.5677 28.4412 79.4103 28.4412C74.3707 28.4236 70.668 24.4821 70.668 19.4971Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M87.6723 21.7331V21.7769C87.6521 23.5462 88.3478 25.249 89.6023 26.5006C90.8569 27.7522 92.5643 28.4469 94.339 28.428C96.1269 28.4444 97.8468 27.7451 99.1132 26.4866C100.38 25.2281 101.087 23.5157 101.076 21.7331V21.6849C101.063 17.9946 98.0513 15.0139 94.35 15.0273C90.6486 15.0406 87.6589 18.0429 87.6723 21.7331ZM99.1059 21.7331V21.7769H99.1103C99.1103 24.4821 97.171 26.7137 94.3829 26.7181C91.6741 26.7181 89.6336 24.4864 89.6336 21.7331V21.6849C89.6336 18.9797 91.5465 16.7262 94.3346 16.7262C97.0434 16.7262 99.1059 18.9797 99.1059 21.7331Z"
			fill="white"
		/>
		<path d="M103.973 10.027H105.886V28.1255H103.973V10.027Z" fill="white" />
		<path d="M109.754 10.027H111.671V28.1255H109.754V10.027Z" fill="white" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M125.097 24.9512C124.076 26.1163 122.594 26.7779 121.042 26.762C118.782 26.762 116.79 25.2011 116.517 22.496H126.702C126.724 22.2023 126.724 22.0006 126.724 21.8296V21.8296C126.724 18.0591 124.539 15.0339 120.735 15.0339C117.19 15.0339 114.578 18.0108 114.578 21.7287C114.578 25.7229 117.476 28.4236 120.994 28.4236C123.038 28.4787 124.993 27.5906 126.293 26.0166L125.097 24.9512ZM120.695 16.6473C123.232 16.6473 124.574 18.629 124.798 20.9615H116.517C116.79 18.48 118.496 16.6473 120.695 16.6473Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M130.08 28.8708L129.2 30.3571C130.916 31.5417 132.958 32.1653 135.045 32.1415C137.085 32.1415 138.8 31.5716 139.944 30.4316C140.986 29.4013 141.584 27.88 141.584 25.8939V15.3057H139.671V17.6119C138.527 15.976 136.645 15.0107 134.645 15.0339C133.032 15.0147 131.48 15.6469 130.341 16.7865C129.203 17.9261 128.576 19.4763 128.602 21.0842V21.1325C128.583 22.7336 129.214 24.2743 130.353 25.404C131.491 26.5338 133.039 27.1564 134.645 27.1302C137.01 27.1302 138.576 25.9158 139.693 24.4295V25.9421C139.693 28.941 137.855 30.5018 135.018 30.5018C133.238 30.5062 131.505 29.9338 130.08 28.8708ZM135.027 16.7218C137.463 16.7218 139.754 18.4273 139.754 21.0579V21.1106H139.746C139.746 23.6885 137.455 25.4467 135.027 25.4686C133.848 25.496 132.708 25.0446 131.869 24.218C131.03 23.3913 130.563 22.2603 130.577 21.0842V21.036C130.577 18.4054 132.591 16.7218 135.027 16.7218Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M154.837 24.9512C153.815 26.1154 152.334 26.7767 150.783 26.762C148.518 26.762 146.53 25.2011 146.258 22.496H156.46C156.486 22.2023 156.486 22.0006 156.486 21.8296C156.486 18.0591 154.296 15.0339 150.492 15.0339C146.948 15.0339 144.336 18.0108 144.336 21.7287C144.336 25.7229 147.234 28.4236 150.752 28.4236C152.789 28.4732 154.735 27.5855 156.029 26.0166L154.837 24.9512ZM150.444 16.6473C152.981 16.6473 154.323 18.629 154.547 20.9615H146.266C146.539 18.48 148.245 16.6473 150.444 16.6473Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M164.157 21.7331V21.7769C164.138 23.5447 164.833 25.2457 166.087 26.4962C167.34 27.7466 169.046 28.4413 170.819 28.4236C172.607 28.4412 174.328 27.7431 175.596 26.4856C176.864 25.2281 177.573 23.5161 177.565 21.7331V21.6849C177.459 18.0598 174.475 15.1793 170.837 15.1924C167.2 15.2055 164.236 18.1073 164.157 21.7331ZM175.59 21.7331V21.7769H175.599C175.599 24.4821 173.66 26.7137 170.863 26.7181C168.154 26.7181 166.114 24.4864 166.114 21.7331V21.6849C166.114 18.9797 168.031 16.7262 170.815 16.7262C173.523 16.7262 175.59 18.9797 175.59 21.7331Z"
			fill="white"
		/>
		<path
			d="M180.989 16.9937H179.23V15.332H180.989V14.2184C180.989 12.754 181.39 11.636 182.111 10.917C182.865 10.2255 183.867 9.86798 184.89 9.92613C185.608 9.90277 186.324 10.0128 187.001 10.2506V11.9122C186.399 11.7108 185.771 11.6015 185.136 11.5878C183.646 11.5878 182.898 12.4647 182.898 14.3148V15.3583H186.979V16.9937H182.924V28.1255H181.007L180.989 16.9937Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M78.1733 35.535H71.0625V52.8925H74.8927V47.684H77.8039C81.7045 47.684 84.84 45.6014 84.84 41.5854V41.5371C84.84 37.9902 82.329 35.535 78.1733 35.535ZM80.9613 41.673C80.9613 43.1593 79.84 44.3036 77.9271 44.3036H74.8928V38.9942H77.8523C79.7652 38.9942 80.9613 39.9149 80.9613 41.6248V41.673Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M86.0117 46.2854V46.3204C86.0117 50.1392 89.0372 53.2038 93.1973 53.2038C97.3574 53.2038 100.436 50.1041 100.436 46.2854V46.2371C100.436 42.4359 97.4101 39.3669 93.2501 39.3669C89.09 39.3669 86.0117 42.4666 86.0117 46.2854ZM96.7065 46.2854V46.3204C96.7065 48.2802 95.4136 49.9419 93.2501 49.9551C91.1524 49.9551 89.732 48.2452 89.732 46.2854V46.2371C89.732 44.2773 91.0249 42.6157 93.1885 42.6157C95.2861 42.6157 96.7065 44.3256 96.7065 46.2854Z"
			fill="white"
		/>
		<path
			d="M102.845 34.794H106.614V52.8925H102.832L102.845 34.794Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M113.738 34.794H109.758V38.1393H113.738V34.794ZM113.65 39.6168H109.859L109.872 52.9057H113.65V39.6168Z"
			fill="white"
		/>
		<path
			d="M116.048 46.3205V46.2854C116.022 44.4344 116.752 42.6525 118.069 41.3481C119.387 40.0437 121.179 39.3287 123.035 39.3669C125.551 39.3669 127.116 40.2087 128.361 41.5985L126.048 44.0801C125.203 43.2032 124.355 42.6157 123.013 42.6157C121.122 42.6157 119.781 44.2774 119.781 46.2371V46.2854C119.781 48.3197 121.1 49.9551 123.163 49.9551C124.429 49.9551 125.3 49.4114 126.219 48.5433L128.418 50.7749C127.082 52.3884 125.066 53.2869 122.969 53.2038C121.127 53.2349 119.351 52.5202 118.047 51.2231C116.742 49.9259 116.021 48.1571 116.048 46.3205Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M134.449 34.794H130.469V38.1393H134.449V34.794ZM134.347 39.6168H130.57V52.9057H134.347V39.6168Z"
			fill="white"
		/>
		<path
			d="M137.395 39.6037H141.172V41.4889C142.052 40.3709 143.164 39.3537 145.077 39.3537C147.935 39.3537 149.602 41.239 149.602 44.2905V52.8926H145.838V45.4787C145.838 43.6942 144.989 42.7779 143.547 42.7779C142.104 42.7779 141.185 43.6942 141.185 45.4787V52.8926H137.395V39.6037Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M153.766 52.6953L152.474 55.5188C154.297 56.4457 156.32 56.9167 158.366 56.8911C160.952 56.8911 162.869 56.3474 164.114 55.1066C165.231 53.9886 165.803 52.2568 165.803 49.8761V39.5861H162.025V41.3399C160.974 40.0507 159.386 39.3176 157.72 39.3538C154.664 39.3538 151.801 41.5854 151.801 45.5532V45.6014C151.801 49.5429 154.611 51.8009 157.72 51.8009C159.734 51.8009 160.952 50.9854 162.073 49.6438V50.2883C162.073 52.669 160.855 53.9097 158.27 53.9097C156.686 53.9206 155.129 53.5007 153.766 52.6953ZM162.073 45.5532V45.6014C162.073 47.4122 160.653 48.6705 158.815 48.6705C156.977 48.6705 155.583 47.4385 155.583 45.6014V45.5532C155.583 43.7469 156.972 42.4842 158.815 42.4842C160.657 42.4842 162.073 43.7425 162.073 45.5532Z"
			fill="white"
		/>
	</svg>
)
